// External Dependencies:
import React from 'react'

// Internal Dependencies:
import Link from 'components/Link/Link'

class CurriculumNav extends React.Component {
	render() {
		return (
			<div className="curriculum-nav">
				<div className="-inner">
					<div className="section-home">
						<div className="-inner">
							<div className="-links">
								<Link to="/achievement-cards" className="-join">
									<span>
										<span>Achievement Cards</span>
									</span>
								</Link>
								<Link to="/way-2-go" className="-way-2-go">
									<span>
										<span>Way 2 Go</span>
									</span>
								</Link>
								<Link to="/evidence-based" className="-evidence-based">
									<span>
										<span>Evidence-Based</span>
									</span>
								</Link>
								<Link to="/specialty" className="-specialty">
									<span>
										<span>Specialty</span>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default CurriculumNav



// WEBPACK FOOTER //
// ./components/CurriculumNav/CurriculumNav.jsx